import React from 'react';
// import { useHistory } from 'react-router';
import CountUp, { startAnimation } from 'react-countup';
import Waypoint from 'react-waypoint';
import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './About.scss';
import {
  FIRST_DAY,
  LAST_DAY,
  YEAR,
  // cventRegistration
  photosLink
} from '../../constants';

const START_TIME = 0;
const DURATION_TIME = 3;

const stats = {
  days: 2,
  speakers: 53,
  presentations: 36,
  labs: 8,
  attendees: 1318
  // viewers: 3600
};

const About = () => {
  // const history = useHistory();
  let animationStarted = false;
  let days;
  let speakers;
  let presentations;
  let labs;
  let attendees;
  // let viewers;

  const startCounter = () => {
    if (!animationStarted) {
      startAnimation(days);
      startAnimation(speakers);
      startAnimation(presentations);
      startAnimation(labs);
      startAnimation(attendees);
      // startAnimation(viewers);
      animationStarted = true;
    }
  };

  return (
    <>
      {/* <div className="about-background" /> */}
      {/* <div id="note">
        <h1>
          We’re very sorry but the registration to OpenSlava {YEAR} is currently unavailable. We’re
          working hard to have it fixed as soon as possible. Please come back later.
        </h1>
      </div> */}
      <div className="save-the-date section">
        {/* <h1>
          Save the date: OpenSlava {YEAR} - October {FIRST_DAY}-{LAST_DAY}
        </h1> */}
        {/* <h1> </h1> */}
        {/* <h1> and stay tuned for more details</h1> */}
        {/* <p>
          Exciting things are coming your way this October! Mark your calendars for{' '}
          <strong>
            October {FIRST_DAY}-{LAST_DAY}, {YEAR}
          </strong>
          , and get ready for an unforgettable experience at OpenSlava. Stay tuned for more details
          - we can’t wait to share what’s in store!
        </p> */}
        {/* <h1>
          We would like to inform you that OpenSlava 2025 registration has reached its maximum
          capacity.
        </h1> */}
        {/* <a
          className="button mr-5 ml-5"
          href={photosLink}
          id="cfs-button"
          rel="noopener noreferrer"
          target="_blank">
          PHOTOS {LAST_YEAR}
        </a> */}
        {/* <button
          className="button ml-5"
          id="cfs-button"
          onClick={() => history.push('/program')}
          type="button">
          RECORDINGS
        </button> */}
        {/* <a
          className="button button-dark"
          href={cventRegistration}
          id="cfs-button"
          rel="noopener noreferrer"
          target="_blank">
          REGISTER NOW
        </a> */}
        {/* <button
          className="button button-dark mr-5"
          id="cfs-button"
          onClick={() => history.push('/livestream')}
          type="button">
          Livestream
        </button>
        <button
          className="button button-dark"
          id="cfs-button"
          onClick={() => history.push('/ff')}
          type="button">
          Feedback Form
        </button> */}
        {/* <a
          className="button button-dark"
          href={cventRegistration}
          id="cfs-button"
          rel="noopener noreferrer"
          target="_blank">
          REGISTER - VIRTUAL
        </a> */}
        <a
          className="button button-dark mr-3 ml-3 mb-3"
          href={photosLink}
          id="cfs-button"
          rel="noopener noreferrer"
          target="_blank">
          PHOTOS
        </a>
        <a
          className="button button-dark mr-3 ml-3"
          href="#/program"
          id="cfs-button"
          rel="noopener noreferrer"
          target="_self">
          RECORDINGS
        </a>
      </div>
      {/* <div className="save-the-date section">
        <p>
          <span>Due to high demand, we’re no longer accepting in-person registrations. </span>
          However, you can still participate in OpenSlava 2025 and enjoy the presentations remotely
          by registering for our virtual conference format. We will provide you with a link for
          online streaming at a later time.
        </p>
      </div> */}
      <section className="section" id="about">
        <div className="container">
          <h1>ABOUT</h1>
          <div className="columns is-variable is-desktop is-multiline is-centered is-mobile">
            <div className="column is-6-desktop is-12-tablet is-12-mobile">
              <p>
                OpenSlava {YEAR} marks the <strong> 13th edition</strong> of our annual conference
                on <strong> emerging technologies</strong> and <strong>open source</strong>,
                organized by <strong>Accenture</strong> in <strong>Bratislava, Slovakia</strong>.
              </p>
              <p>
                OpenSlava is more than just a conference - it’s a dynamic gathering of{' '}
                <strong>
                  innovators, thought leaders, experienced developers, tech architects
                </strong>
                , and
                <strong> everyone passionate about technology, open source, and innovation</strong>.
                Whether you’re a seasoned professional or an enthusiastic newcomer, OpenSlava brings
                together a diverse community eager to
                <strong> explore the latest trends, learn,</strong> and
                <strong> share insights</strong>, while sparking
                <strong> meaningful conversations</strong> about the future of tech.
              </p>
              <div className="as-paragraph">
                Over the course of two exciting days, attendees can expect a dynamic program filled
                with insightful sessions, hands-on workshops, and engaging discussions.
                <br />
                <strong>
                  <span>
                    Day 1, October {FIRST_DAY}, {YEAR}: Hands-on Labs day
                  </span>
                </strong>
                <ul>
                  <li>
                    A day of interactive, deep-dive workshops designed for small groups (20-30
                    participants) to explore emerging technologies in a practical, collaborative
                    setting.
                  </li>
                </ul>
                <strong>
                  <span>
                    Day 2, October {LAST_DAY}, {YEAR}: Main conference day
                  </span>
                </strong>
                <ul>
                  <li>
                    Keynotes, presentations, and lightning talks on the latest tech trends,
                    alongside an exhibition area and networking opportunities to connect with
                    industry professionals.
                  </li>
                  {/* <li>
                    Leitmotiv of the conference will be “Uniting Technology and Sustainability”
                  </li> */}
                </ul>
              </div>
              {/* <div className="as-paragraph">
                <strong>
                  <span>OpenSlava {YEAR}: What can you look forward to?</span>
                </strong>
                <p>
                  Building upon the success of previous editions, OpenSlava 2025 will further
                  explore the transformative power of AI and GenAI, the critical importance of
                  security in a digital world, the limitless potential of cloud and data, and the
                  emerging frontiers of quantum computing, spatial computing, and robotics.
                </p>
                <p>
                  Once again, we will bring together industry leaders, ecosystem partners,
                  innovators, and experts to share insights and foster collaboration. Whether you
                  are a seasoned tech architect, software developer, business leader, technology
                  consultant, IT student, or simply a technology enthusiast interested in the latest
                  tech trends, there will be something for everyone. The conference promises to be
                  an exceptional platform for learning, sharing ideas, networking, and exploring the
                  future of technology.
                </p>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>Format of the conference</span>
                </strong>
                <p>Hybrid combining in-person conference with online streaming</p>
              </div> */}
              {/* <div className="as-paragraph">
                <strong>
                  <span>Consider attending OpenSlava {YEAR} if you are:</span>
                </strong>
                <ul>
                  <li>Technology architect</li>
                  <li>Software developer</li>
                  <li>IT and business consultant</li>
                  <li>IT student and teacher from IT faculties/universities</li>
                  <li>
                    IT and business enthusiast interested in innovations, the latest trends in open
                    source, and emerging technologies.
                  </li>
                </ul>
              </div> */}
              <p>
                As part of our commitment to growing the OpenSlava community and ensuring
                accessibility for all,{' '}
                <strong>registration for the conference will remain free of charge</strong>.
                {/* However, please note that capacity is limited, so secure your spot by{' '} */}
                {/* We have reached the maximum capacity for in-person participation.{' '}
                <a href={cventRegistration} rel="noopener noreferrer" target="_blank">
                  Register for online streaming
                </a>{' '}
                and don’t miss OpenSlava {YEAR}! */}
              </p>
              {/* <p> */}
              {/* We would like to inform you that
                <strong> OpenSlava 2025 registration has reached its maximum capacity </strong>
                at this time. */}
              {/* We invite you to consider joining the waiting list by accessing the
                registration link provided above. If we are unable to accommodate your request for
                onsite attendance, we will ensure that you receive a link for online streaming at a
                later point. */}
              {/* </p> */}
              <p>
                Having evolved into an international event over the years, OpenSlava attracts top
                speakers and participants from across the globe. To connect this diverse community,{' '}
                <strong>the conference will be held in English</strong>.
              </p>
              <p>Stay tuned for more updates as we unveil what’s in store for this year’s event!</p>
              <p>
                Do you want to learn more about the organizer? Visit{' '}
                <a
                  href="https://www.accenture.com/sk-sk/careers"
                  rel="noopener noreferrer"
                  target="_blank">
                  {' '}
                  www.accenture.sk
                </a>
                .
              </p>
            </div>
            <div className="column is-6-desktop is-12-tablet is-12-mobile" id="youtube-column">
              {/* <LazyLoadTransition> */}
              <div className="card">
                <iframe
                  allowFullScreen
                  src="https://www.youtube.com/embed/G9kSc75S70g?si=JaKNOPXtXNsSa7yF"
                  title="Openslava Aftermovie"
                  width="100%"
                />
                <footer className="footer-wrapper">
                  <strong>
                    <p className="card-footer-item">Aftermovie from OpenSlava {YEAR}</p>
                  </strong>
                </footer>
              </div>
              {/* </LazyLoadTransition> */}
            </div>
          </div>

          <LazyLoadTransition>
            <h1 className="section-title openslava-numbers is-hidden-mobile">
              OpenSlava {YEAR} in numbers
              {/* OpenSlava {YEAR} in numbers */}
            </h1>
            <Waypoint onEnter={startCounter} />
            <div className="columns is-variable is-desktop is-mobile is-multiline is-hidden-mobile is-centered">
              <div className="column is-1-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      days = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.days}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Days</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      speakers = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.speakers}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Speakers</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      presentations = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.presentations}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Presentations</div>
              </div>
              <div className="column is-2-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      labs = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.labs}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Hands-on Labs</div>
              </div>
              <div className="column is-3-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      attendees = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.attendees}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Onsite participants</div>
              </div>
              {/* <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      viewers = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.viewers}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Unique viewers</div>
              </div> */}
            </div>
          </LazyLoadTransition>
        </div>
      </section>
    </>
  );
};

export default About;
